import { useTranslation } from 'react-i18next';

import { Text } from '../../atoms/text/text';

const PasswordRequirements = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Text className="mb-2" size="sm">
        {t('page.account.changePasswordForm.passwordRequirements.title')}
      </Text>
      <ul className="list-disc pl-4.5 [&_li]:mt-0">
        <Text size="sm" tag="li">
          {t('page.account.changePasswordForm.passwordRequirements.minLength')}
        </Text>
        <Text size="sm" tag="li">
          {t('page.account.changePasswordForm.passwordRequirements.uppercase')}
        </Text>
        <Text size="sm" tag="li">
          {t('page.account.changePasswordForm.passwordRequirements.lowercase')}
        </Text>
        <Text size="sm" tag="li">
          {t('page.account.changePasswordForm.passwordRequirements.numeric')}
        </Text>
        <Text size="sm" tag="li">
          {t('page.account.changePasswordForm.passwordRequirements.symbol')}
        </Text>
      </ul>
    </div>
  );
};

export { PasswordRequirements };
